import {
  ApiCartChangeCartPaymentAddressFailedAction,
  ApiCartChangeCartPaymentAddressSucceededAction,
  apiCartChangeCartPaymentAddressFailedType,
  apiCartChangeCartPaymentAddressRequested,
  apiCartChangeCartPaymentAddressSucceededType
} from '../../api/cart/changeCartPaymentAddressApi';
import {
  ChangeCurrentCartPaymentAddressRequestedAction,
  changeCurrentCartPaymentAddressFailed,
  changeCurrentCartPaymentAddressSucceeded
} from '../../carts/cartsSlice';
import { put, race, take } from 'typed-redux-saga';
import { ChangeCartPaymentAddressResult } from '../../../graphql/cart/changeCartPaymentAddress';
import { CustomOrderType } from '../../carts/CustomOrderType';
import convertCartToStateCart from '../../../converters/convertCartToStateCart';
import generateActionId from '../../../generateActionId';

function* changeCurrentCartPaymentAddressSaga({
  payload: { actionId: requestedActionId, address: paymentAddress, customOrderType }
}: ChangeCurrentCartPaymentAddressRequestedAction): Generator {
  const actionId: number = generateActionId();
  yield* put(
    apiCartChangeCartPaymentAddressRequested({
      actionId,
      customOrderType,
      paymentAddress,
      parentActionId: requestedActionId
    })
  );

  yield* actionsLoop(actionId, requestedActionId, customOrderType);
}

function* actionsLoop(
  actionId: number,
  requestedActionId: number,
  customOrderType: CustomOrderType
): Generator {
  let isSameActionId: boolean = false;
  do {
    const { succeeded, failed } = yield* race({
      succeeded: take<ApiCartChangeCartPaymentAddressSucceededAction>(
        apiCartChangeCartPaymentAddressSucceededType
      ),
      failed: take<ApiCartChangeCartPaymentAddressFailedAction>(
        apiCartChangeCartPaymentAddressFailedType
      )
    });

    isSameActionId =
      succeeded?.payload.requestedActionId === actionId ||
      failed?.payload.requestedActionId === actionId;

    if (isSameActionId) {
      if (succeeded !== undefined) {
        const { cart, error }: ChangeCartPaymentAddressResult = succeeded.payload.result;
        if (cart === null || error !== null) {
          yield* put(
            changeCurrentCartPaymentAddressFailed({
              requestedActionId
            })
          );
        } else {
          yield* put(
            changeCurrentCartPaymentAddressSucceeded({
              cart: convertCartToStateCart(cart),
              customOrderType,
              requestedActionId
            })
          );
        }
      } else if (failed !== undefined) {
        yield* put(
          changeCurrentCartPaymentAddressFailed({
            requestedActionId
          })
        );
      }
    }
  } while (!isSameActionId);
}

export default changeCurrentCartPaymentAddressSaga;
